//@flow
import * as React from 'react'
import type { HermesQualityReviewContainer$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const HermesQualityReviewContainer=(props:HermesQualityReviewContainer)=>{
    const hermes = props.hermes
    let isVisible = false

    if (hermes.reviewQuestions && hermes.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'hermesQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'hermesPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(hermes.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default HermesQualityReviewContainer


// WEBPACK FOOTER //
// ./src/views/ProjectHermes/QualityReviewContainer.js